export default import.meta.ROLLUP_FILE_URL_Vk61FbE_I0f6EzBZ3FEHrw